import { getGroupPermissionFactory, PermissionEnum } from '../../../common';
import { CustomerProfilesPermissions } from './customer-management.customer-profiles.permissions';

export class CustomerProfileVehiclesPermissions {
  static GroupName = `${CustomerProfilesPermissions.GroupName}.Vehicles`;

  static getPermissions = getGroupPermissionFactory(
    CustomerProfileVehiclesPermissions.GroupName,
  );

  static Permissions = {
    ReadAll: CustomerProfileVehiclesPermissions.getPermissions(
      PermissionEnum.READ_ALL,
    ),
  };
}
